export const collectionKeys = {
  BLOG: process.env.REACT_APP_COL_BLOG,
  CAREER: process.env.REACT_APP_COL_CAREER,
  CLIENTS: process.env.REACT_APP_COL_CLIENTS,
  META: process.env.REACT_APP_COL_META,
  FAQ: process.env.REACT_APP_COL_FAQ,
  REFERAL: process.env.REACT_APP_COL_REFERAL
};
